import React, { Component } from "react";
import Helmet from "react-helmet";
import Mousetrap from "mousetrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import NProgress from "nprogress";

import Header from "../components/Header";
import NoMatch from "./NoMatch";
import Footer from "../components/Footer";
import PageShow from "../components/PageShow";
import PageEdit from "../components/PageEdit";
import "./Page.css";

class Page extends Component {
  constructor(props) {
    super(props);
    NProgress.start();

    // Aliases to props for convenience
    this.name = this.props.match.params.name
      ? this.props.match.params.name
      : Page.DEFAULT_NAME;
    this.wiki = this.props.wiki;

    // Local state that does not need to be tracked
    this.hasToggledOnce = false;
    this.saveToastId = null;

    this.state = {
      title: "",
      content: "",
      hasFetched: false,
      mode: this.props.mode ? this.props.mode : Page.Mode.SHOW
    };
  }

  componentWillMount() {
    this.fetchContent_(this.name);
  }

  componentDidMount() {
    Mousetrap.bind(Page.EDIT_KEY, () => {
      if (this.props.user) {
        this.toggleEditMode_();
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const nextName = nextProps.match.params.name
      ? nextProps.match.params.name
      : Page.DEFAULT_NAME;

    if (nextName !== this.name) {
      NProgress.start();
      this.name = nextName;
      this.hasToggledOnce = false;
      this.fetchContent_();
    }

    if (nextProps.mode !== this.props.mode) {
      this.setState({
        mode: nextProps.mode
      });
    }
  }

  render() {
    // Show error page if there is no page content (making sure that we have
    // tried fetching it) except when we are in edit mode.
    if (
      this.state.mode !== Page.Mode.EDIT &&
      this.state.hasFetched &&
      this.state.content.length === 0
    ) {
      return (
        <div>
          <NoMatch />
        </div>
      );
    }

    return (
      <div>
        <Helmet>
          <title>
            {this.state.title}
          </title>
        </Helmet>
        <PageEdit
          content={this.state.content}
          setContent={this.setContent_}
          isEditMode={this.state.mode === Page.Mode.EDIT}
          toggleEditMode={this.toggleEditMode_}
        />
        <div
          className={
            "type-page-container " +
            (this.state.mode === Page.Mode.EDIT
              ? "type-page-container-editmode"
              : "")
          }
        >
          <div className="type-page-content">
            {/* Don't show header for home page. */}
            {this.name !== Page.DEFAULT_NAME &&
              <Header isPageLoaded={this.state.hasFetched} />}
            <PageShow
              history={this.props.history}
              content={this.state.content}
              setTitle={this.setTitle_}
            />
            <Footer
              user={this.props.user}
              pagePath={this.getPagePath_()}
              pageMode={this.state.mode}
              isPageLoaded={this.state.hasFetched}
            />
          </div>
        </div>
        <ToastContainer autoClose={3000} />
      </div>
    );
  }

  setTitle_ = title => {
    if (title !== this.state.title) {
      this.setState({ title: title });
    }
  };

  fetchContent_() {
    // Fire off async event to get content from store
    this.setState({
      hasFetched: false
    });
    this.wiki
      .get(this.name)
      .then(snapshot => {
        // If page does not exist, the snapshot value is null (errors are for
        // actual server errors).
        const page = snapshot.val();
        this.setState({
          // Reset content back to empty string if it doesn't exist.
          content: page ? page.content : "",
          hasFetched: true
        });
        NProgress.done();
      })
      .catch(err => {
        toast.error(
          "Page could not be loaded. Check your internet connection and try " +
            `again? Reason: ${err.message}`,
          {
            autoClose: 10000
          }
        );
      });
  }

  setContent_ = content => {
    this.setState({ content: content });
    // If saving the page has failed once, don't try again unless user manually
    // involves saving.
    // TODO(mikexstudios): Remove this flag once proper authentication handling
    // and error recovery has been implemented.
    this.props.wiki
      .setContent(this.name, content)
      .then(() => {
        toast.dismiss(this.saveToastId);
        this.saveToastId = null;
      })
      .catch(err => {
        if (!this.saveToastId) {
          this.saveToastId = toast.error(
            "Save failed. You are now in Preview mode where changes are not " +
              `saved! Reason: ${err.message}.`,
            { autoClose: false, closeButton: false }
          );
        }
      });
  };

  toggleEditMode_ = () => {
    // The idea here is that:
    // 1. We don't want to keep pushing urls to history when user toggles
    //    between show and edit modes or else user will have a ton of history
    //    spam.
    // 2. But at the same time, we want at least one history entry when
    //    toggling modes.
    // Thus, we check to see if the user has toggled the mode once before. If
    // so, go back in history. If not, then push state again.
    if (this.hasToggledOnce) {
      this.props.history.goBack();
      this.hasToggledOnce = false;
      return;
    }
    this.hasToggledOnce = true;

    const pagePath = this.getPagePath_();
    if (this.state.mode === Page.Mode.SHOW) {
      this.props.history.push(`${pagePath}/_edit`);
    } else {
      this.props.history.push(`${pagePath}`);
    }
  };

  getPagePath_ = () => {
    return `/${this.name}`;
  };
}

/** Class static constants. */
Page.DEFAULT_NAME = "home";
Page.EDIT_KEY = "esc";

/** Enum for page modes. */
Page.Mode = {
  SHOW: "show",
  EDIT: "edit"
};

export default Page;



// WEBPACK FOOTER //
// ./src/containers/Page.js